import { checkIsBlockedDomain, checkIsValidEmail, checkMinMaxLength } from './validation-helpers';

const formFieldClass = '.js-form_field';
const invalidClass = 'm-invalid';

export function validateFields(fields) {
  if (!fields || !fields.length) return false;

  let hasInvalidFields = false;

  fields.forEach(field => {
    if (!validateField(field)) {
      hasInvalidFields = true;
    }
  });

  return hasInvalidFields;
}

function showError(element) {
  const formField = element.closest(formFieldClass);

  formField && formField.classList.add(invalidClass);
}

function hideError(element) {
  const formField = element.closest(formFieldClass);

  formField && formField.classList.remove(invalidClass);
}

function validateField(field) {
  if (field.tagName === 'INPUT') return validateInput(field);

  if (field.tagName === 'TEXTAREA') {
    const isValid = checkMinMaxLength(field);
    isValid ? hideError(field) : showError(field);
    return isValid;
  }

  if (field.tagName === 'SELECT') {
    const isValid = !field.required || field.value !== '';
    isValid ? hideError(field) : showError(field);
    return isValid;
  }

  return true;
}

function validateInput(input) {
  const value = input.value.trim();
  const valueLength = value.length;
  const isRequired = input.required;
  let isValid = true;

  // TEXT
  if (input.type === 'text') {
    isValid = checkMinMaxLength(input);
  }

  // EMAIL
  if (input.type === 'email') {
    if (isRequired || valueLength > 0) {
      isValid = checkIsValidEmail(value) && !checkIsBlockedDomain(value);
    }
  }

  // TEL
  if (input.type === 'tel') {
    const inputMask = input.inputmask;

    if (inputMask) {
      const phoneNumbers = inputMask.unmaskedvalue();

      if ((isRequired || phoneNumbers.length > 0) && phoneNumbers.length < 5) {
        isValid = false;
      }
    }
  }

  // CHECKBOX
  if (input.type === 'checkbox') {
    if (isRequired) {
      isValid = input.checked;
    }
  }

  // FILE
  // if (input.type === 'file') {}

  // Show/hide error
  isValid ? hideError(input) : showError(input);

  return isValid;
}
